import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChange,
} from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState, NO_SCROLL } from 'src/app';

interface ComboItem {
  id: string | number;
  name: string;
  isGroup?: boolean;
  group?: string;
}
@Component({
  // tslint:disable-next-line:component-selector
  selector: 'combo-select',
  templateUrl: './comboSelect.component.html',
  styleUrls: ['./comboSelect.component.scss'],
})
export class ComboSelectComponent implements OnInit, OnChanges {
  @Input() resultsList: ComboItem[];
  @Input() title: string;
  @Input() isFunds = false;
  @Input() isHTML = false;
  @Input() class = 'combo-select';
  @Input() sentSelected: any;
  @Input() placeholder = '';
  @Input() noClick = false;
  @Input()
  @Output()
  emitSelectedItem: EventEmitter<any> = new EventEmitter();

  public selectedItem: any = {};
  public isComboOpen = false;
  public attachedClick = true;
  public selected = false;
  public onlineList: any = [];
  public hasOffline = false;
  public offlineList: any = [];

  constructor(public el: ElementRef, private store: Store<AppState>) {}

  ngOnInit() {
    const aux = this.class && this.class.split(' ');

    aux.forEach(
      (value) =>
        this.el.nativeElement && this.el.nativeElement.classList.add(value),
    );
  }

  ngOnChanges(changes: { [propKey: string]: SimpleChange }) {
    let orderAux: any;

    if (changes.resultsList === undefined) {
      return;
    }
    this.selectedItem = {};
    if (changes.resultsList.currentValue !== undefined) {
      this.resultsList = changes.resultsList.currentValue;
      this.checkforOffline();
      this.checkForGroups();
    }
    if (changes.sentSelected !== undefined) {
      if (changes.sentSelected.currentValue !== undefined) {
        orderAux = changes.sentSelected.currentValue;
        this.setOrderType(orderAux);
      }
    }
  }

  public closeWhenOutsideClick(event: any) {
    if (this.isComboOpen) {
      this.attachedClick = !this.attachedClick;
      this.isComboOpen = !this.isComboOpen;
      this.noScroll(false);
    }
  }

  public setOrderType(item: Partial<ComboItem>) {
    this.closeWhenOutsideClick(true);
    if (this.noClick) {
      return;
    }

    this.selected = true;
    this.selectedItem = {
      ...item,
      name: !this.isHTML ? this.htmlToPlaintext(item.name) : item.name,
    };
    this.emitSelectedItem.emit(this.selectedItem);

    this.noScroll(false);
  }

  public navDown(event: any, order = { id: 0, name: '' }) {
    const code = event.keyCode;
    const source = event.srcElement;

    if (code === 13) {
      if (source.classList.contains('option')) {
        this.setOrderType(order);
      }
    }
    if (code === 40) {
      if (source.classList.contains('input-search')) {
        // input
        source.parentElement.parentElement.querySelector('.option').focus();
      } else if (source.classList.contains('face-select')) {
        source.parentElement.querySelector('.option').focus();
      } else if (source.classList.contains('option')) {
        // option
        if (source.nextElementSibling === null) {
          return;
        }
        source.nextElementSibling.focus();
      }
    } else if (code === 38) {
      // up
      if (source.classList.contains('option')) {
        if (source.previousElementSibling === null) {
          return;
        }
        source.previousElementSibling.focus();
      }
    }
  }

  public toggleCombo(event: any) {
    if (this.noClick) {
      return;
    }
    this.isComboOpen = !this.isComboOpen;
    this.selected = false;

    if (this.isComboOpen) {
      if (event && event.srcElement) {
        const inputSearchEl = event.srcElement
          .closest('.select')
          .querySelector('.input-search');
        inputSearchEl && inputSearchEl.focus();
      }
      this.noScroll(true);
    } else {
      this.noScroll(false);
    }
  }

  public hideOrderList() {
    this.isComboOpen = false;
  }

  private reset() {
    this.hasOffline = false;
    this.onlineList = [];
    this.offlineList = [];
  }

  private checkforOffline() {
    this.reset();
    if (this.isFunds) {
      this.resultsList.filter((item: any) => {
        if (item.offline) {
          this.hasOffline = true;
          this.offlineList.push(item);
        } else {
          this.onlineList.push(item);
        }
      });
    }
  }

  private checkForGroups() {
    const [firstElement] = this.resultsList;
    if (!firstElement || !firstElement.group) {
      return false;
    }

    const groupPositions: string[] = [];
    const groupCollection = (
      this.resultsList as Array<{
        id: number;
        name: string;
        group: string;
      }>
    ).reduce((collection, item) => {
      item.group &&
        groupPositions.indexOf(item.group) === -1 &&
        groupPositions.push(item.group);

      collection[item.group] = [...(collection[item.group] || []), item];

      return collection;
    }, {} as any);

    let listWithGroups: any[] = [];
    for (const groupName of groupPositions) {
      listWithGroups = [
        ...listWithGroups,
        { name: groupName, isGroup: true },
        ...groupCollection[groupName],
      ];
    }
    this.resultsList = listWithGroups;
  }

  private htmlToPlaintext(text: string) {
    return text ? String(text).replace(/<[^>]+>/gm, ' ') : '';
  }

  /**
   * This function blocks/unblocks the scroll to the body element
   */
  private noScroll(block: boolean) {
    this.store.dispatch({
      type: NO_SCROLL,
      payload: { block, source: 'ComboSelectComponent' },
    });
  }
}
